import { Colors, Icon, Spacer, TagLabel, FloatingBox, Typography, } from '@zapier/design-system';
import InAppSidebarSubheaderButton from './InAppSidebarSubheaderButton';
import { Fragment, useRef, useState } from 'react';
import { css, jsx } from '@emotion/react';
import { useUniversalNavContext } from '../../../hooks/useUniversalNavContext';
import { emitUserInteractionEvent } from '../../../utils/avroEvents';
const MENU_WIDTH = '240px';
const MenuStyles = css({
    display: 'flex',
    flexDirection: 'column',
    maxHeight: 'inherit',
    boxSizing: 'border-box',
    overflow: 'auto',
    padding: 'var(--zds-space-8, 8px)',
    width: MENU_WIDTH,
    left: '3px',
    top: '30px',
    outline: 'none',
});
const MenuItemStyles = css({
    display: 'flex',
    gap: 'var(--zds-space-12, 12px)',
    padding: 'var(--zds-space-8, 8px)',
    borderRadius: '4px',
    cursor: 'pointer',
    position: 'relative',
    alignItems: 'center',
    '&:focus-visible, &:hover': {
        backgroundColor: 'var(--zds-ui-brand-weakest, #FDF5F2)',
    },
    '&:focus-visible': {
        outline: 'var(--zds-border-focus, 2px solid #695BE8)',
        outlineOffset: 'var(--zds-space-2, 2px)',
    },
});
const IconWrapperStyles = (isActive) => css({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 'var(--zds-space-8, 8px)',
    borderRadius: '4px',
    backgroundColor: isActive
        ? 'var(--zds-ui-brand-weakest, #FDF5F2)'
        : 'var(--zds-background-strong, #F5F3EB)',
    '& svg': {
        fill: isActive ? `${Colors.zapier}` : 'var(--zds-text-default, #413735)',
    },
});
const TitleWrapperStyles = css({
    font: `var(--zds-body-1, 400 14px/24px ${Typography.base.fontFamily})`,
    color: 'var(--zds-text-default, #413735)',
});
const DescriptionWrapperStyles = css({
    font: `var(--zds-minimal-print-1, 400 12px/20px ${Typography.base.fontFamily})`,
    color: 'var(--zds-text-weaker, #574E4C)',
});
const CreationItem = ({ description, href, icon, iconFilled, id, tag, target, title, }) => {
    const [isActive, setIsActive] = useState(false);
    const { getFullyQualifiedURL } = useUniversalNavContext();
    return (jsx("a", { css: MenuItemStyles, href: getFullyQualifiedURL(href), id: id, target: target, onFocus: () => setIsActive(true), onBlur: () => setIsActive(false), onMouseEnter: () => setIsActive(true), onMouseLeave: () => setIsActive(false), onClick: () => {
            emitUserInteractionEvent({
                event_action: 'click',
                option_selected: `UniversalSidebar CreateDropdown: ${title}`,
            });
        }, "data-zds": true },
        jsx("div", { "data-zds": true, css: IconWrapperStyles(isActive) },
            jsx(Icon, { name: isActive ? iconFilled : icon, size: 20, shouldAnimateFill: false })),
        jsx("div", { css: {
                display: 'flex',
                flexDirection: 'column',
            }, "data-zds": true },
            jsx("div", { css: { display: 'flex', alignItems: 'center' }, "data-zds": true },
                jsx("span", { "data-zds": true, css: TitleWrapperStyles }, title),
                tag && (jsx(Fragment, null,
                    jsx(Spacer, { width: 8 }),
                    jsx(TagLabel, { size: "small", color: "simple" }, tag)))),
            jsx("span", { "data-zds": true, css: DescriptionWrapperStyles }, description))));
};
export const CreateDropdown = ({ items }) => {
    const { isCreateMenuOpen, setIsCreateMenuOpen } = useUniversalNavContext();
    const buttonRef = useRef(null);
    return (jsx("div", { ref: buttonRef, style: { position: 'relative' }, "data-zds": true },
        jsx(InAppSidebarSubheaderButton, { iconName: "formAdd", onClick: (event) => {
                event.stopPropagation();
                emitUserInteractionEvent({
                    event_action: 'click',
                    option_selected: `UniversalSidebar CreateDropdown ${isCreateMenuOpen ? 'close' : 'open'}`,
                });
                setIsCreateMenuOpen(!isCreateMenuOpen);
            }, text: "Create" }),
        isCreateMenuOpen && (jsx(FloatingBox, { borderColor: "transparent", borderRadius: 4, maxWidth: MENU_WIDTH, onClickOutside: (event) => {
                if (buttonRef &&
                    buttonRef.current &&
                    !buttonRef.current.contains(event.target))
                    setIsCreateMenuOpen(false);
            } },
            jsx("div", { css: MenuStyles, "data-zds": true }, items.map((item) => (jsx(CreationItem, Object.assign({}, item, { key: item.id })))))))));
};
//# sourceMappingURL=CreateDropdown.js.map
// @zapier/universal-layout@9.14.1 (2aac35652)
